import React, { useRef } from 'react';
import { HotFilterGroupConfiguration } from '@config/catalog/hotfilter-group-configurations';
import HotFilterButton from '@components/organisms/hot-filters/hot-filter-button/hot-filter-button';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';

interface CatalogBooleanHotfilterProps {
  filterGroup: HotFilterGroupConfiguration;
}

const CatalogBooleanHotfilter: React.FC<CatalogBooleanHotfilterProps> = ({ filterGroup }) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const toggleFilter = useContextSelector(CatalogContext, (v) => v.toggleFilter);
  const filters = useContextSelector(CatalogContext, (v) => v.filters);
  const handleToggleFilter = () => {
    toggleFilter(filterGroup.facet, []);
  };
  const isSelected = !!filters?.[filterGroup.facet];

  return (
    <HotFilterButton
      ref={buttonRef}
      label={filterGroup.label}
      onClick={handleToggleFilter}
      isSelected={isSelected}
      isBooleanFilter={true}
      dataCy={`${filterGroup.label}.BUTTON`}
    />
  );
};

export default CatalogBooleanHotfilter;
